/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react';

import axios from 'axios';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { apiHost } from '../utils/request';
import RegistrationForm from './registrationForm';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import RegisterAsSalesRepAndManager from './schema';
import ProfileInfo from './profileInfo';

import '../../assets/css/registration.css';
import '../../assets/css/registration_media_queries.css';

const Registration = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isError, setError] = useState(null);
  const [recaptcha, setRecaptcha] = useState();

  const [processingQueryData, setProcessingQueryData] = useState(true);
  const [isRedirectedFromPassport, setIsRedirectedFromPassport] = useState(
    false
  );
  const [paramsData, setParamsData] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });

  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      USER_AUTHENTICATION: { labels, confirmationDialog }
    }
  } = localizedStrings;

  // extract and store data from query params (if any)
  useEffect(() => {
    const queryParams = new URLSearchParams(history.location.search);
    const firstName = decodeURIComponent(queryParams.get('firstName') || '');
    const lastName = decodeURIComponent(queryParams.get('lastName') || '');
    const email = decodeURIComponent(queryParams.get('email') || '');

    if (firstName && lastName && email) setIsRedirectedFromPassport(true);

    setParamsData({
      firstName: firstName || '',
      lastName: lastName || '',
      email: email || ''
    });

    setProcessingQueryData(false);
  }, []);

  const onChange = value => {
    setRecaptcha(value);
  };
  const handleSubmit = async (values, actions) => {
    setError(null);
    setLoading(true);
    values.recaptcha = recaptcha;
    const updatedValues = {
      ...values,
      province: +values.role === 11 ? values.multiProvinces : values.province,
      channel:
        +values.role === 11
          ? values.multiChannels
          : _.get(values, 'channel.0.id', ''),
      dealership: _.get(values, 'dealership.0.id', '')
    };

    axios
      .post(`${apiHost}/users/register`, updatedValues)
      .then(response => {
        const { status } = response && response.data;
        setShowModal(true);
        setLoading(false);
        if (status) {
          setShowModal(!showModal);
        }
        setLoading(false);
        actions.resetForm({});
      })
      .catch(err => {
        const {
          data: { error }
        } = err && err.response;

        setShowModal(false);
        setLoading(false);
        setError(error);
        actions.resetForm({});
      })
      .then(() => {
        setLoading(false);
        actions.resetForm({});
      });
  };

  return processingQueryData ? (
    <></>
  ) : (
    <>
      <div id="main">
        <div id="main-wrapper">
          <div id="main-content">
            <ProfileInfo error={isError} />
            <div id="main-content-login">
              <RegistrationForm
                initialValues={{
                  firstName: paramsData.firstName,
                  lastName: paramsData.lastName,
                  email: paramsData.email,
                  password: '',
                  channel: '',
                  multiChannels: '',
                  outlet: '',
                  salesManager: '',
                  salesManagerEmail: '',
                  cpmsId: '',
                  contactNumber: '',
                  province: '',
                  multiProvinces: [],
                  recaptcha: '',
                  channelOrgCode: '',
                  dealership: '',
                  xid: '',
                  storeCode: ''
                }}
                schema={RegisterAsSalesRepAndManager}
                labels={labels}
                showModal={showModal}
                loading={loading}
                onChange={value => onChange(value)}
                confirmationDialog={confirmationDialog}
                onSubmit={(values, actions) => {
                  handleSubmit(values, actions);
                }}
                isRedirectedFromPassport={isRedirectedFromPassport}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Registration.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};

export default Registration;
